import type { AnalyticsEntity } from './revelio-primary-filter-entity-switch';

/**
 * In-memory persistence for the last tab a user opened within each page
 * group (Company, Geography, Role).
 */
const lastViewedTabByEntity = new Map<AnalyticsEntity, string>();

export const getLastViewedTab = (entity: AnalyticsEntity): string | null =>
  lastViewedTabByEntity.get(entity) ?? null;

export const setLastViewedTab = (
  entity: AnalyticsEntity,
  tabId: string
): void => {
  // A bookmarked URL with a trailing slash still matches its route, but the
  // raw pathname would miss the exact-key page-config lookup and the pages-id
  // guard on restore — store the canonical form.
  lastViewedTabByEntity.set(entity, tabId.replace(/\/+$/, ''));
};
